import { Component, Input, OnChanges, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Notification } from '../notifications-history.model';
import { notificationList } from '../notificationList';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

interface NotificationObject {
  title: string;
  val: string;
  checked?: boolean;
}

@Component({
  selector: 'app-notifications-history',
  templateUrl: './notifications-history.component.html',
  styleUrls: ['./notifications-history.component.scss'],
  standalone: false
})
export class NotificationsHistoryComponent implements OnChanges {
  @Input() notifications: Notification[] | null;
  @Input() lastViewed: number;
  @Input() loading: boolean;
  @Input() nextPageLoading: boolean;
  @Input() noMoreNotifications: boolean;
  @Input() notificationTypesStorage: [] = [];
  @Output() loadMoreNotifications = new EventEmitter();
  @Output() filterNotificationHistory = new EventEmitter();
  unreadNotifications: Notification[] = [];
  notificationList: NotificationObject[];
  notificationTypes: NotificationObject[] = [];
  sameDay: boolean;
  start: string | undefined;
  end: any | undefined;
  today: any;
  minDate: Date;
  range = new UntypedFormGroup({
    start: new UntypedFormControl(),
    end: new UntypedFormControl()
  });

  constructor(private router: Router) {
    this.today = new Date();
    this.minDate = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate() - 7);
    this.notificationList = notificationList;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.calculateUnreadNotifications();
    if (changes.notificationTypesStorage && this.notificationTypesStorage?.length) {
      this.setNotificationList(changes.notificationTypesStorage.currentValue);
    }
  }

  calculateUnreadNotifications() {
    if (!this.lastViewed) {
      return;
    }
    this.unreadNotifications = (this.notifications || [])
      .filter(x => x.timestamp * 1000 > this.lastViewed);
  }

  handleDate() {
    this.sameDay = false;
    if (this.range.value.start && this.range.value.end) {
      this.start = this.range.value.start.toISOString().split('T', 1).toString();
      this.end = this.range.value.end.toISOString().split('T', 1).toString();
      const now  = this.today.toISOString().split('T', 1).toString();

      if (this.end === now) {
        const hhMM = this.today.toISOString().split('T')[1];
        this.end = this.end.concat('T', hhMM);
      }

      if (this.start === this.end) {
        this.handleClearDates();
        return this.sameDay = true;
      }
      this.handleFilters();
    }
  }

  setNotificationList(types: string[]): void {
    types.forEach(type => {
      notificationList.forEach(nl => {
         if (nl.val === type && !this.notificationTypes?.some(nt => nt.val.includes(type))) {
          this.handleNotificationType({ checked: true }, nl, false);
         }
      });
    });
  }

  handleNotificationType(event, item: NotificationObject, handleFilters: boolean = true) {
    if (event.checked) {
      item.checked = true;
      this.notificationTypes.push(item);
      if (handleFilters) {
        this.handleFilters();
      }
    }
    if (!event.checked) {
      item.checked = false;
      const index = this.notificationTypes.indexOf(item);
      this.notificationTypes.splice(index, 1);
      if (handleFilters) {
        this.handleFilters();
      }
    }
  }

  handleFilters() {
    const criteria = {
      types: this.mapNotificationAttr(),
      start: this.start,
      end: this.end,
      reset: true
    };
    this.filterNotificationHistory.emit(criteria);
  }

  handleClearTypes() {
    this.notificationTypes.forEach(item => {
      item.checked = false;
    });
    this.notificationTypes.splice(0, this.notificationTypes.length);
    this.handleFilters();
  }

  handleSelectAllTypes() {
    this.notificationTypes.splice(0, this.notificationTypes.length); // Clear current selections
    this.notificationList.forEach(item => {
      item.checked = true;
      this.notificationTypes.push(item);
    });
    this.handleFilters();
  }

  handleClearDates() {
    this.range.reset();
    this.start = undefined;
    this.end = undefined;
    this.handleFilters();
  }

  handleNextPage() {
    if (this.notificationTypes.length || (this.start && this.end)) {
      const criteria = {
        types: this.mapNotificationAttr(),
        start: this.start,
        end: this.end,
        reset: false
      };
      this.loadMoreNotifications.emit(criteria);
    } else {
      const criteria = {
        types: [] = [],
        start: undefined,
        end: undefined,
        reset: false
      };
      this.loadMoreNotifications.emit(criteria);
    }
  }

  mapNotificationAttr() {
    return this.notificationTypes.map((type) => type.val);
  }

  navigateTo(notification: Notification): void {
    if (notification.type === 'assignment') {
      this.router.navigateByUrl('/today');
    } else {
      this.router.navigateByUrl(`/borrower/${notification.borrowerId}`);
    }
  }
}
